import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SliderComponent } from "./slider/slider.component";
import { PlotlyComponent } from "./plotly/plotly.component";
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ParameterFilterBoxComponent } from "./parameter-filter-box/parameter-filter-box.component";

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  declarations: [SliderComponent, PlotlyComponent, ParameterFilterBoxComponent],
  exports: [SliderComponent, PlotlyComponent, ParameterFilterBoxComponent],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts